const _ = `         ,\\
         \\\\\\,_
          \\\` ,\\
     __,.-" =__)
   ."        )
,_/   ,    \\/\\_
\\_| )_-\\ \\_-\`
   \`-----\` \`--\``;
export {
  _ as default
};
